import * as React from 'react';
import WordCloud from './word_cloud';
// var echarts = require('echarts');
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: null,
      word_string: [], // 具体要显示的内容
      word_cloud: [], // 具体要显示的内容
      moreVis: false,
      wordPrefix20: [],
      str: null,
    };
  }
  UNSAFE_componentWillMount() {
    // console.log('this.props.content', this.props.content);
    if (this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.content !== this.props.content) {
      this.setState({ content: this.props.content }, () => {
        this.findData();
      });
    }
  }
  // 查找要显示的内容
  findData = () => {
    let content = this.state.content;
    console.log('content: ', content);
    if (content && content.length > 0) {
      let find = content.find(v => { return v.label === 'word_string_ele' });
      if (find && find.content && find.content.length > 0) {
        let find2 = find.content.find(y => { return y.label === 'word_string' });
        if (find2) {
          if (find2 && find2.content && find2.content.length > 0) {
            let allWords = find2.content.split(',');
            // allWords = allWords.concat(allWords);
            // allWords = allWords.concat(allWords);
            // allWords = allWords.concat(allWords);
            let wordPrefix20 = [];
            if (allWords && allWords.length > 20) {
              wordPrefix20 = allWords.slice(0, 20); // 截取前20条
            }
            this.setState({ word_string: find2.content, wordPrefix20 }, () => {
              //  console.log(this.state.data);
            });
          }
        }
      }
      let findword_cloud = content.find(v => { return v.label === 'wordcloud_ele' });
      if (findword_cloud && findword_cloud.content && findword_cloud.content.length > 0) {
        let findwordcloud = findword_cloud.content.find(y => { return y.label === 'wordcloud' });
        if (findwordcloud) {
          if (findwordcloud && findwordcloud.content && findwordcloud.content.data && findwordcloud.content.data.length > 0) {
            let originData = findwordcloud.content.data;
            originData = originData.map(v => { return { name: v[0], value: v[1] } });

            this.setState({ word_cloud: originData }, () => {
              // console.log('word_cloud: ', this.state.word_cloud);
            });
          }
        }
      }
      let findElse = content.find(v => { return v.label === 'ills_ele' });
      console.log('findElse: ', findElse);
      if (findElse && findElse.content && findElse.content.length > 0) {
        let str = findElse.content.find(y => { return y.label === 'illustration' });
        console.log('str: ', str);
        if (str && str.content) {
          this.setState({ str: str.content });
        }
      }
    }
  }
  moreClick = () => {
    this.setState({ moreVis: !this.state.moreVis });
  }
  render() {
    const { word_string, wordPrefix20, moreVis } = this.state;
    // console.log('word_cloud:', word_cloud);
    return (
      <React.Fragment>
        {
          this.state.word_string &&
          <React.Fragment>
            {/* <p>magnetic(1), resonance(1), frontal(0.8), corpus(0.6), cerebellum(0.6), amygdala(0.5), cerebral(0.5), lobes(0.4),anatomical(0.4), cerebellar(0.4), creatine(0.3), dorsal(0.3), nuclei(0.3), morphometry(0.3), anisotropy(0.2), limbic(0.2),naa(0.2), radial(0.2), tensor(0.2), neuroanatomical(0.2), neuroanatomy(0.2), cortex(0.2), hemisphere(0.2), dti(0.1),glx(0.1), purkinje(0.1), sulcus(0.1), ganglia(0.1), hemispheres(0.1), medial(0.1)，magnetic(1), resonance(1), frontal(0.8), corpus(0.6), cerebellum(0.6), amygdala(0.5), cerebral(0.5), lobes(0.4),anatomical(0.4), cerebellar(0.4), creatine(0.3), dorsal(0.3), nuclei(0.3), morphometry(0.3), anisotropy(0.2), limbic(0.2),naa(0.2), radial(0.2), tensor(0.2), neuroanatomical(0.2), neuroanatomy(0.2), cortex(0.2), hemisphere(0.2), dti(0.1),glx(0.1), purkinje(0.1), sulcus(0.1), ganglia(0.1), hemispheres(0.1), medial(0.1)</p> */}
            <p>
              {wordPrefix20.length <= 0 && word_string &&
                word_string
              }
              {wordPrefix20.length > 0 && moreVis === false &&
                wordPrefix20
              }
              {wordPrefix20.length > 0 && moreVis === true &&
                word_string
              }
            </p>
            {/* <p>这里默认限制上面获取的条数，如显示前20条，如果超过20条就显示MORE+，点击MORE+，显示所有的数据，并且出现MORE-，点击MORE-恢复到只显示前20条，如果不超过20条，则不出现任何MORE</p> */}
            {
              wordPrefix20.length > 0 &&
              <div className="more">
                {
                  !moreVis &&
                  <div className="plus" onClick={this.moreClick}></div>
                }
                {
                  moreVis &&
                  <div className="minus" onClick={this.moreClick}></div>
                }
              </div>
            }
            {
              this.state.word_cloud && this.state.word_cloud.length > 0 &&
              <WordCloud word_cloud={this.state.word_cloud} />
            }
            {/* <p>ERC属于一类实体，这类实体在全局条件下特异性分布在Autism相关文献中，并富集在当前类别内容中，实体后括号中数字代表实体在特定文本（对当前类别内容最有代表性的前n篇文献）中出现的频率，ERC是分类的基础。</p> */}
            <p>{this.state.str}</p>
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Summary;